import { useCallback, useState } from "react"

export const useLocalStorage = (key: string, initialState: string) => {
	const [value, setValue] = useState(localStorage.getItem(key) ?? initialState)

	const updatedSetValue = useCallback(
		(newValue: string) => {
			if (newValue === initialState || typeof newValue === "undefined") {
				localStorage.removeItem(key)
			} else {
				localStorage.setItem(key, newValue)
			}
			setValue(newValue ?? initialState)
		},
		[initialState, key],
	)

	return [value, updatedSetValue] as const
}
